var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25ZM5.99985 25.0001C5.99985 35.4767 14.5233 44.0001 24.9999 44.0001C35.4766 44.0001 43.9999 35.4767 43.9999 25.0001C43.9999 14.5236 35.4764 6.00015 24.9999 6.00015C14.5233 6.00015 5.99985 14.5236 5.99985 25.0001Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.1668 19.229H30.381C32.4321 19.0531 37.5298 18.752 37.5298 18.752C37.5298 18.752 37.8344 19.3748 38.1055 20.0999C38.3766 20.8249 38.5434 21.5085 38.5434 21.5085C38.5434 21.5085 32.671 21.183 30.3822 20.9867V22.5H23.3682C15.3517 22.5 14.1668 19.229 14.1668 19.229ZM26.788 33.1667C25.5241 33.1667 24.4176 32.5222 23.8074 31.558C23.4104 30.9308 22.6674 30.5806 21.9058 30.6616C19.4688 30.9203 12.5149 31.3463 12.5149 31.3463C12.5149 31.3463 12.0681 30.4577 11.8011 29.6864C11.534 28.915 11.3838 28.2705 11.3838 28.2705C11.3838 28.2705 19.2468 28.7227 21.9058 29.0051C22.6677 29.086 23.4102 28.7361 23.8073 28.1086C24.4176 27.1444 25.524 26.5 26.7879 26.5L35.5001 27.2595V27.5411V27.8228L28.3293 27.7963C27.9668 27.7949 27.6721 28.0885 27.6721 28.4511C27.6721 28.7978 27.9424 29.0844 28.2885 29.1048L35.5001 29.5286V29.8334V30.1383L28.2885 30.5621C27.9424 30.5824 27.6721 30.869 27.6721 31.2157C27.6721 31.5783 27.9668 31.8719 28.3293 31.8705L35.5001 31.8441V32.1257V32.4074L26.788 33.1667Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.8b03eff16b3f26ff7ef3bb3c3a2faa57.svg";
export { ForwardRef as ReactComponent };